import React from 'react';
import { format, subMonths } from 'date-fns';
import { DateField } from '../form/DateField';
interface QuickDateProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  showPresets?: boolean;
}
export function QuickDate({
  label,
  value,
  onChange,
  required,
  showPresets = true
}: QuickDateProps) {
  const setPreset = (months: number) => {
    const d = subMonths(new Date(), months);
    onChange(format(d, 'yyyy-MM-dd'));
  };
  return <div className="space-y-2" data-id="element-16">
      <DateField label={label} value={value} onChange={onChange} required={required} data-id="element-17" />
      {showPresets && <div className="flex flex-wrap gap-2" data-id="element-18">
          <button type="button" onClick={() => setPreset(6)} className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded hover:bg-gray-200" data-id="element-19">
            6 Months Ago
          </button>
          <button type="button" onClick={() => setPreset(12)} className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded hover:bg-gray-200" data-id="element-20">
            1 Year Ago
          </button>
          <button type="button" onClick={() => setPreset(24)} className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded hover:bg-gray-200" data-id="element-21">
            2 Years Ago
          </button>
          <button type="button" onClick={() => setPreset(60)} className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded hover:bg-gray-200" data-id="element-22">
            5 Years Ago
          </button>
        </div>}
    </div>;
}